'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var loading = { loadingFeis: true };

exports.default = function (feis_id) {
  return function (state) {
    var groupFees = (0, _paths.getGroupFeesForFeis)(state, feis_id);
    if (groupFees.get('loading')) {
      return loading;
    }
    return {
      groupFees: groupFees.toJS(),
      groupFeesInit: groupFees.toJS(),
      newGroupFees: [],
      loadingFeis: false
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/landing-page/mapStateToController.js
// module id = 587
// module chunks = 0